import {supabase,adminSupabase} from '@/lib/supabase';
export interface OrgFreeze {organization_id:string;frozen:boolean;at:string|null;by:string|null;reason:string|null}
export interface ResumePlan {pending:number;recent:number;will_send:number;expired:number;reconnect_required:boolean}
export async function outboxFreeze<T>(action:string,organizationId?:string,reason?:string,excludeRecent=true):Promise<T>{
  const {data:{session}}=await supabase.auth.getSession();
  if(!session)throw new Error('unauthorized');
  const {data,error}=await adminSupabase.functions.invoke('admin-outbox-freeze',{headers:{Authorization:`Bearer ${session.access_token}`},body:{action,organization_id:organizationId,reason,exclude_recent:excludeRecent}});
  if(error)throw error;
  if(data?.error)throw new Error(data.error);
  return data as T;
}
